function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M481.7,304.7c-76.8,0-152.7,0-228.5,0c-8.8-34,0.3-55.1,31.6-69.3c51.8-23.5,104.6-25.1,157.4-3.2 C478.4,247.3,486.7,262.8,481.7,304.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M368,73.3c32.5,0.2,57.7,26,57.4,58.8c-0.2,33.3-26.1,58.7-59.6,58.3c-32.6-0.4-57.7-26.1-57.5-58.9 C308.5,98.3,334.4,73,368,73.3z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M325.3,426.7c-102.1,0-203.2,0-304,0c-11.8-45.2,0.4-73.3,42.1-92.2c69-31.3,139.1-33.4,209.4-4.2 C320.8,350.3,331.9,371,325.3,426.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M173.9,118.8c43.2,0.3,76.7,34.6,76.4,78.2c-0.3,44.3-34.8,78-79.3,77.6c-43.3-0.5-76.8-34.7-76.5-78.3 C94.8,152.1,129.3,118.5,173.9,118.8z"
})));

var SvgRoles = function SvgRoles(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRoles, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/roles.33d1b840.svg";
export { ForwardRef as ReactComponent };